import React from 'react';
import './Page.css';
import GrowthAnimation from '../components/GrowthAnimation';

const Home: React.FC = () => {
  return (
    <div className="page">
      <div className="page-hero" style={{ backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('/images/hero.jpg')" }}>
        <h1 className="animate-fade-up">Take Your Business to the Next Level</h1>
        <p className="hero-subtitle animate-fade-up delay-200">Accounting, Bookkeeping and Tax Services</p>
        <p className="hero-description animate-fade-up delay-400">At Growbal, we combine conventional accounting services and tax with cutting-edge technology to harness the power of accounting industry changes and make them work for you.</p>
      </div>
      
      <div style={{ backgroundColor: '#fff' }}>
        <div className="page-content">
          <section className="content-section" style={{ marginBottom: 0 }}>
            <div className="content-with-image">
              <div className="content-text animate-fade-up delay-300">
                <h2>North Island Advisors</h2>
                <p>Growbal operates as a recognised public practice under both CA ANZ and CPA Australia. Located on Auckland’s North Shore, we proudly support clients throughout New Zealand with tailored services covering Virtual CFO, Accounting, Tax, Advisory, and Inventory Management. Contact our friendly team to explore a package that best suits your business needs.</p>
              </div>
              <div className="content-image animate-fade-up delay-500">
                <GrowthAnimation />
              </div>
            </div>
          </section>
        </div>
      </div>

      <div style={{ backgroundColor: '#f8f9fa' }}>
        <div className="page-content">
          <section className="content-section language-section" style={{ textAlign: 'center', marginBottom: 0 }}>
            <div style={{ maxWidth: '800px', margin: '0 auto 40px' }} className="animate-fade-up">
              <h2>Accountants Who Speak Your Language</h2>
            </div>

            <div style={{ marginBottom: '40px' }} className="animate-fade-up delay-200">
              <img 
                src="/images/languages-1.jpg" 
                alt="Multilingual Team" 
                style={{ maxWidth: '100%', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }} 
              />
            </div>

            <div style={{ maxWidth: '800px', margin: '0 auto' }} className="animate-fade-up delay-400">
              <p style={{ fontSize: '18px', lineHeight: '1.8', color: '#555' }}>
                The team at Growbal doesn't use complicated terminology or confusing words. We want to make sure you understand how your business is going, the implications of important business decisions and what you need to do to improve. We're fluent in both English, Chinese and Hindi and are happy to speak with you in the language you prefer.
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Home;
